import React from 'react';

import styled from 'styled-components';

interface Props {
  children: string;
  size?: number;
}

export function ShortcutKey({children, size = 1}: Props): JSX.Element {
  return (
    <StyledButtonDiv size={size}>
      <span>{children}</span>
    </StyledButtonDiv>
  );
}

interface StyledButtonDivProps {
  size: number;
}

const StyledButtonDiv = styled.div<StyledButtonDivProps>`
  display: inline-block;
  min-width: ${({size}) => 30 * size}px;
  border: 0 solid #d6d6e7;
  border-bottom-width: 2px;
  border-radius: 4px;
  box-shadow: 0 4px 11px 0 rgb(37 44 97 / 15%),
    0 1px 3px 0 rgb(93 100 148 / 60%);
  background-image: linear-gradient(
    to left top,
    #f5f5fa,
    rgba(214, 214, 231, 0.6)
  );

  > span {
    font-size: ${({size}) => 1 * size}rem;
    border: 0 solid #fff;
    width: 100%;
    padding: 2px 6px;
    line-height: 1.5;
    justify-content: center;
    align-items: center;
    display: flex;
    border-left-width: 1px;
    border-right-width: 1px;
    border-top-width: 1px;
    border-radius: 4px;
  }
`;
